







import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

@Component
export default class ConfirmSection extends Vue {
  @Prop({ required: true })
  title: string

  @Prop({ required: true })
  content: string

  style() {
    return {
      'p-3': true,
      'm-0': true,
    }
  }
}
